import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { INSTRUCTIONS_SCROLL_KEY, TITLE_SCROLL_KEY } from '@instructure/quiz-common';
import ScrollableQuizTitle from '../title/Title';
import ScrollableQuizInstructions from '../instructions/Instructions';
import PropTypes from 'prop-types';
export var QuizInfo = /*#__PURE__*/function (_Component) {
  function QuizInfo() {
    _classCallCheck(this, QuizInfo);
    return _callSuper(this, QuizInfo, arguments);
  }
  _inherits(QuizInfo, _Component);
  return _createClass(QuizInfo, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ScrollableQuizTitle, Object.assign({}, this.props, {
        scrollKey: TITLE_SCROLL_KEY
      })), !this.props.hideInstructions && /*#__PURE__*/React.createElement(ScrollableQuizInstructions, Object.assign({}, this.props, {
        scrollKey: INSTRUCTIONS_SCROLL_KEY
      })));
    }
  }]);
}(Component);
_defineProperty(QuizInfo, "propTypes", {
  hideInstructions: PropTypes.bool
});
_defineProperty(QuizInfo, "defaultProps", {
  hideInstructions: false
});
export default QuizInfo;